<template>
  <div class="footer py-4 mt-10 d-flex flex-lg-column" id="kt_footer">
    <div class="d-flex flex-column-reverse flex-lg-row align-items-center justify-content-between container">
      <div class="nav d-lg-block py-1">
        <span class="footer-text">{{ currentYear }}</span>
        <span class="footer-text">
          ©
          <a :href="CIRX_URL" target="_blank" class="nav-link d-inline p-0">
            {{ translate("FOOTER.CIRCULARX_LINK") }}
          </a>
        </span>
        <span class="footer-text"> - {{ releaseVersion }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint no-unused-vars:off */
import { CIRX_URL } from "@/core/constants/cirxConstants.js";
import useTranslate from "@/core/composables/translate";

const { translate } = useTranslate();

const currentYear = new Date().getFullYear();
const releaseVersion = process.env.VUE_APP_RELEASE;
</script>
